// ✅ US Market Services - Thin Wrapper (DRY principle)
import ServicesPage from '../../sub/services';
import SEOHead from '../../../components/SEOHead';

export default function USServices() {
  return (
    <>
      <SEOHead
        title='Our Services | US Market | LBVisible'
        description='Comprehensive digital services for US businesses: web development, SEO, and local ranking.'
        keywords='digital services USA, web development USA, SEO services USA'
        canonicalUrl='/us/sub/services'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/sub/services' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/sub/services' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/sub/paslaugos' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/sub/services' },
        ]}
      />

      <ServicesPage />
    </>
  );
}
